import { Injectable } from '@angular/core';
import { catchError, map, take } from 'rxjs/operators';
import {
  HttpClient,
  HttpHeaders,
  HttpParams
} from '@angular/common/http';
import { ConnectionDetailsResultModel, PharmacyData,PharmacyGridDataMapper } from '../features/DTO/pharmacy';
import { PharmacySearchModel } from '../features/DTO/pharmacy-search';
import { PharmacyCRUDModel, PharmacyCRUDResultModel,PharmacyLookupDataMapper } from '../features/DTO/pharmacy-crud';
import { FuncsService } from '../services/funcs.service';
import { PharmacyStoreModel,PharmacyStoreResultModel } from '../features/DTO/pharmacy-store-crud';
import { PharmacyStoreSearchRequestModel, PharmacyStoreSearchResponseModel, PharmacyStoreSearchGridDataMapper } from '../features/DTO/pharmacy-store-search';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { ConnectionDetails } from '../features/DTO/pharmacy';
import { Vendor, VendorListMapper, VendorResponseModel, VendorDataMapper } from '../features/DTO/vendor';
import { PharmacyStoreSyncSearchRequestModel, PharmacyStoreSyncSearchResponseModel, PharmacyStoreSyncSearchGridDataMapper } from '../features/DTO/pharmacy-store-sync-search';
@Injectable({
    providedIn: 'root'
  })

  export class VendorService {
    private vendorListMapper = new VendorListMapper();
    private vendorDataMapper = new VendorDataMapper();

    constructor(private http: HttpClient, private globalFunc:FuncsService) { 

    }

    getVendors(): Observable<any> {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        })
      };
         return this.http.get(environment.configUIAPIUrl+"/vendor-list",httpOptions)
         .pipe(take(1), map((data: any) => this.vendorListMapper?.mapToModel(data["ResponseData"])))
         .pipe(catchError(this.globalFunc.error));
        }

    getVendorDetails(vendor:Vendor) {
        let filteredVendor = {
          VendorId: vendor.VendorId // Only sending VendorId
        };
        let data = JSON.stringify(filteredVendor);
          return this.http.post<VendorResponseModel>(environment.configUIAPIUrl+"/vendor-detail",data)
          .pipe(take(1), map((data: any) => this.vendorDataMapper.mapToModel(data["ResponseData"])))
          .pipe(catchError(this.globalFunc.error));
        }

    addVendor(vendor:Vendor) {
      let data:any=JSON.stringify(vendor);
      return this.http.post<VendorResponseModel>(environment.configUIAPIUrl+"/vendor-add",data)
      .pipe(catchError(this.globalFunc.error));
    }

    updateVendor(vendor:Vendor) {
      let data:any=JSON.stringify(vendor);
      return this.http.put<VendorResponseModel>(environment.configUIAPIUrl+"/vendor-update",data)
      .pipe(catchError(this.globalFunc.error));
    }

    testConnection(pharmacyModel:ConnectionDetails) {
      let data:any=JSON.stringify(pharmacyModel);
      console.log(environment);
      console.log(environment.testConnectivityUrl);
      console.log(environment.pharmacyListUrl);
      return this.http.post<ConnectionDetailsResultModel>(environment.testConnectivityUrl,data)
      .pipe(catchError(this.globalFunc.error));
    }
  }
  
